import { useState, useEffect } from 'react';
import useSWR from 'swr';
import useSWRMutation from 'swr/mutation'
import { getVoteStatus, getPtp, postPtp } from 'src/api';
import { useUser } from 'src/context';

// 類鐵粉挑戰
const CHALLENGES = [
  {
    id: 'Q1',
    content: '《薩莉亞修道院》這部電影一張票價多少錢？',
    options: [
      {
        key: 'a',
        text: '444',
      },
      {
        key: 'b',
        text: '666',
      },
      {
        key: 'c',
        text: '888',
      }
    ]
  },
  {
    id: 'Q2',
    content: '《誤入異世界成為宗教領袖的我》這間工作室出品的最新遊戲是跟哪一部電影合作？',
    options: [
      {
        key: 'a',
        text: '紅衣小女孩',
      },
      {
        key: 'b',
        text: '黃衣小飛俠',
      },
      {
        key: 'c',
        text: '黑衣老司機',
      }
    ]
  },
  {
    id: 'Q3',
    content: '《被詛咒的武士，轉生至雨之神域》原本的遊戲是一場什麼夢？',
    options: [
      {
        key: 'a',
        text: '美夢',
      },
      {
        key: 'b',
        text: '惡夢',
      },
      {
        key: 'c',
        text: '偵探夢',
      }
    ]
  },
  {
    id: 'Q4',
    content: '致敬《光頭村》這部電影的工作室名稱裡面含有哪個元素？',
    options: [
      {
        key: 'a',
        text: '食物',
      },
      {
        key: 'b',
        text: '動物',
      },
      {
        key: 'c',
        text: '色彩',
      }
    ]
  },
  {
    id: 'Q5',
    content: '致敬《Good2.0》這部電影的工作室最初的地點在哪裡？',
    options: [
      {
        key: 'a',
        text: '台北',
      },
      {
        key: 'b',
        text: '台中',
      },
      {
        key: 'c',
        text: '高雄',
      }
    ]
  },
  {
    id: 'Q6',
    content: '《花月宴》的電影海報為什麼跟工作室的遊戲一樣？',
    options: [
      {
        key: 'a',
        text: '因為主辦單位懶得畫新的',
      },
      {
        key: 'b',
        text: '因為《花月宴》是第三屆金逃獎年度最佳遊戲',
      },
      {
        key: 'c',
        text: '因為工作室堅持要用同一張海報',
      }
    ]
  },
  {
    id: 'Q7',
    content: '在《浴門神社》原本遊戲的海報中，鳥居上的匾額有著什麼圖案？',
    options: [
      {
        key: 'a',
        text: '泡湯木桶',
      },
      {
        key: 'b',
        text: '鎖頭',
      },
      {
        key: 'c',
        text: '五芒星',
      }
    ]
  },
  {
    id: 'Q8',
    content: '《金剛石醫院》這部電影是拿哪一個真實存在的醫院故事進行改編？',
    options: [
      {
        key: 'a',
        text: '花崗石醫院',
      },
      {
        key: 'b',
        text: '大理石醫院',
      },
      {
        key: 'c',
        text: '藍寶石醫院',
      }
    ]
  },
  {
    id: 'Q9',
    content: '請問以下哪一個元素沒有出現在電影海報圖片中？',
    options: [
      {
        key: 'a',
        imgSrc: '/img/goty2024/game-9a.png',
      },
      {
        key: 'b',
        imgSrc: '/img/goty2024/game-9b.png',
      },
      {
        key: 'c',
        imgSrc: '/img/goty2024/game-9c.png',
      }
    ]
  }
]

// 對話選項配置
const COUNTER_OPTIONS = [
  { id: 1, text: '想知道關於更多【金逃影展】的秘辛！', next: 'a' },
  { id: 2, text: '今年有遊戲玩嗎？', next: 'b' },
  { id: 3, text: '第一階段提名的資深玩家是怎麼選出來的？', next: 'c' },
  { id: 4, text: '有什麼需要我幫忙的嗎？', next: 'd', conditional: true, showAtStep: 0 },
  { id: 5, text: '✨ 我調查完畢了！ ✨', showAtStep: 1 },
  { id: 6, text: '✨ 我收到你的訊息了！ ✨', next: 'g', showAtStep: 2 },
];

// 特殊對話選項（當滿足條件時顯示）
const SPECIAL_OPTIONS = [
  { id: 'yes', text: '交給我吧', next: 'f' },
  { id: 'no', text: '轉身離開', next: 'back' },
];

// 回覆訊息配置
const REPLY_MESSAGES = {
  default: <p>歡迎來到金逃影展！有什麼想知道的都可以問我！</p>,
  a: <p>可以追蹤逃脫吧的 Threads （脆），可以搜尋 @escapebar.tw 或是直接<a href="https://www.threads.com/@escapebar.tw" target="_blank" rel="noopener noreferrer" className="text-[#0D6072] underline">點這裡前往</a>！</p>,
  b: <p>玩什麼遊戲？今年初好像有個叫做「金蛇燈謎」的遊戲，我覺得還不錯！可惜限量是殘酷的，沒玩到的話幫你 QQ</p>,
  c: <p>本次提名玩家的資格是有在前兩年的金逃獎活動中成功獲得任一斐逃斐榮譽會員稱號，並且有遊玩許多 2024 年新遊戲的資深玩家！</p>,
  d: <p>現在沒什麼需要幫忙的，趕緊去逛逛金逃影展，投你所愛，愛你所選！</p>,
  e: <p>現在忙得有點分身乏術，如果有人願意幫忙就太好了⋯⋯</p>,
  f: <p>嘿！那太好啦！事情是這樣的：<br/>（她探出老式售票亭的窗口，壓低聲音，用有點神秘但語氣親切地說）<br/>不知道為什麼最近來到這間戲院的人都像中了邪一樣，一旦開始看就會一部又一部地看下去⋯⋯<br/>我感覺案情並不單純，不如你先去幫我調查一下牆上那些海報有什麼玄機吧！調查完畢再回來找我！</p>,
  g: <p>太好了！你真的回來了！<br/>（她神秘地壓低聲音說）<br/>根據我的調查，我發現在晚上八點後那些海報會變得不太尋常，有目擊者跟我說那些海報居然動了起來！<br/>我已經幫你準備了一些可以幫助你調查的道具，你會願意幫我接著調查的吧？<br/>（她一直盯著你笑，笑到你心裡發寒）<br/>這裡有手電筒、放大鏡、望遠鏡、鏟子，如果還有缺些什麼的話⋯⋯你應該有辦法自己弄到吧？<br/>調查完成後戲院大門會為你開啟，記得在影展結束前完成調查呀！</p>
};

// 對話狀態管理
const useConversationState = () => {
  const [currentOptions, setCurrentOptions] = useState(COUNTER_OPTIONS);
  const [replyMessage, setReplyMessage] = useState(REPLY_MESSAGES.default);
  const [conversationHistory, setConversationHistory] = useState([]);
  const [isSpecialMode, setIsSpecialMode] = useState(false);
  const [selectedOptionId, setSelectedOptionId] = useState(null);
  
  // 挑戰相關狀態
  const [isChallengeMode, setIsChallengeMode] = useState(false);
  const [isShowingResult, setIsShowingResult] = useState(false);
  const [challengeQuestions, setChallengeQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [challengeAnswers, setChallengeAnswers] = useState({});

  const { isLoadingUser, isLogin } = useUser();

  const { data, isLoading, mutate } = useSWR(`goty2024-voteStatus`, getVoteStatus);
  // isLogin 才 Call 這個 API
  const { data: ptpData, isLoading: ptpLoading, mutate: ptpMutate } = useSWR(isLogin ? `goty2024-ptp` : null, getPtp);

  const { trigger, isMutating } = useSWRMutation(
    isLogin ? `goty2024-ptp` : null, 
    (url, { arg }) => postPtp(arg),
    {
      onSuccess: (res) => {
        ptpMutate();
        // 根據 res.data.result 處理下一步
        if (res.data.result === 'SUCCESS' || res.data.result === 'FAILED') {
          handleChallengeResult(res.data.result);
        }
      },
    }
  );

  const votedData = data?.data?.voted || {};
  const isVoted = Object.keys(votedData).length > 0;

  const ptpStep = ptpData?.data?.step || 0;

  // 根據 step 過濾選項
  const getFilteredOptions = () => {
    return COUNTER_OPTIONS.filter(option => {
      if (option.showAtStep !== undefined) {
        return option.showAtStep === ptpStep;
      }
      return true; // 沒有 showAtStep 的選項總是顯示
    });
  };

  // 開始挑戰
  const startChallenge = () => {
    // 隨機選擇 5 題
    const shuffledChallenges = [...CHALLENGES].sort(() => Math.random() - 0.5);
    const selectedChallenges = shuffledChallenges.slice(0, 5);
    setChallengeQuestions(selectedChallenges);
    setCurrentQuestionIndex(0);
    setChallengeAnswers({});
    setIsChallengeMode(true);
    setCurrentOptions([]);
  };

  // 處理挑戰答案選擇
  const handleChallengeAnswer = (questionId, answerKey) => {
    setChallengeAnswers(prev => ({
      ...prev,
      [questionId]: answerKey
    }));
    
    // 如果還有下一題
    if (currentQuestionIndex < challengeQuestions.length - 1) {
      setCurrentQuestionIndex(prev => prev + 1);
    } else {
      // 挑戰完成，送出答案
      const answer = {
        ...challengeAnswers,
        [questionId]: answerKey
      };
      
      // 立即隱藏選項，避免狀態衝突
      setCurrentOptions([]);
      setIsChallengeMode(false);
      setChallengeQuestions([]);
      setCurrentQuestionIndex(0);
      setChallengeAnswers({});
      
      trigger({ answer });
    }
  };

  // 處理挑戰結果
  const handleChallengeResult = (result) => {
    // 確保沒有選項顯示
    setCurrentOptions([]);
    setIsShowingResult(true);
    
    if (result === 'SUCCESS') {
      setReplyMessage(<p>看來你真的有點實力！<br/>
        這件事情得低調進行⋯⋯聽好囉，我只說一次！<br/>
        接下來的調查比較棘手，我得先去張羅一些道具，準備好之後我會通知你。<br/>
        怎麼通知？你知道「通知中心」在哪吧？時機成熟時你會從那裡知道⋯⋯<br/>
        拜託你，收到訊息後再回來幫忙！</p>);
    } else if (result === 'FAILED') {
      setReplyMessage(<p>你是認真想幫忙嗎？後面還有很多人在排隊，晚點再來吧！</p>);
    }
  };

  // 當 ptpStep 變化時更新選項
  useEffect(() => {
    if (!isSpecialMode && !isChallengeMode && !isShowingResult && currentOptions.length > 0) {
      setCurrentOptions(getFilteredOptions());
    }
  }, [ptpStep, isSpecialMode, isChallengeMode, isShowingResult]);

  const resetConversation = () => {
    setCurrentOptions(getFilteredOptions());
    setReplyMessage(REPLY_MESSAGES.default);
    setConversationHistory([]);
    setIsSpecialMode(false);
    setIsChallengeMode(false);
    setIsShowingResult(false);
    setChallengeQuestions([]);
    setCurrentQuestionIndex(0);
    setChallengeAnswers({});
    setSelectedOptionId(null);
  };

  const handleOptionSelect = (option) => {
    // 設置選中狀態
    setSelectedOptionId(option.id);
    
    // 記錄對話歷史
    setConversationHistory(prev => [...prev, option]);

    if (option.next === 'back') {
      // 回到上一步
      const newHistory = conversationHistory.slice(0, -1);
      setConversationHistory(newHistory);
      
      if (newHistory.length === 0) {
        resetConversation();
      } else {
        const lastOption = newHistory[newHistory.length - 1];
        setReplyMessage(REPLY_MESSAGES[lastOption.next]);
        setCurrentOptions(getFilteredOptions());
        setIsSpecialMode(false);
      }
      return;
    }

    // 檢查是否為條件性選項
    if (option.conditional) {
      if (isVoted) {
        setReplyMessage(REPLY_MESSAGES.e);
        setCurrentOptions(SPECIAL_OPTIONS);
        setIsSpecialMode(true);
      } else {
        setReplyMessage(REPLY_MESSAGES[option.next]);
      }
    } else {
      // 檢查是否為挑戰選項
      if (option.id === 5) {
        startChallenge();
        return;
      }
      
      setReplyMessage(REPLY_MESSAGES[option.next]);
      
      // 如果回覆是 f 或 g，隱藏所有對話選項並觸發 API
      if (option.next === 'f' || option.next === 'g') {
        setCurrentOptions([]);
        trigger();
      } else if (isSpecialMode) {
        setCurrentOptions(getFilteredOptions());
        setIsSpecialMode(false);
      }
    }
  };

  return {
    currentOptions,
    replyMessage,
    conversationHistory,
    isSpecialMode,
    isChallengeMode,
    isShowingResult,
    challengeQuestions,
    currentQuestionIndex,
    selectedOptionId,
    handleOptionSelect,
    handleChallengeAnswer,
    handleChallengeResult,
    resetConversation,
    getFilteredOptions,
  };
};

const PuzzleOptionButton = ({ children, onClick, selected = false }) => {
  const getVariantClasses = () => {
    if (selected) {
      return 'bg-[#7B2337] border-[#7B2337] text-white';
    }
    return 'bg-white border-[#7B2337] text-[#7B2337] hover:bg-[#7B2337] hover:text-white';
  };

  const getDecorationClasses = () => {
    return {
      border: 'border-[#7B2337]',
      bg: 'bg-[#7B2337]'
    };
  };

  const decorationClasses = getDecorationClasses();

  return (
    <button
      onClick={onClick}
      className={`relative w-full p-3 md:p-4 text-left border-2 rounded-lg transition-all duration-300 group overflow-hidden min-h-[44px] md:min-h-[52px]
        ${getVariantClasses()}
      `}
    >
      <div className={`absolute inset-0.5 ${decorationClasses.border} opacity-10 rounded-lg`}></div>
      <div className={`absolute -inset-1 ${decorationClasses.border} opacity-10 rounded-lg scale-0 group-hover:scale-100 transition-transform duration-300`}></div>
      <div className={`absolute -left-1 top-1/2 -translate-y-1/2 w-0.5 h-2/3 ${decorationClasses.bg} opacity-10 group-hover:h-full transition-all duration-300`}></div>
      <div className={`absolute -right-1 top-1/2 -translate-y-1/2 w-0.5 h-2/3 ${decorationClasses.bg} opacity-10 group-hover:h-full transition-all duration-300`}></div>
      <div className="flex items-center justify-center">
        <div className="text-center">{children}</div>
      </div>
    </button>
  );
}

const CounterModal = ({ isOpen, onClose }) => {
  const {
    currentOptions,
    replyMessage,
    conversationHistory,
    selectedOptionId,
    isChallengeMode,
    isShowingResult,
    challengeQuestions,
    currentQuestionIndex,
    handleOptionSelect,
    handleChallengeAnswer,
    resetConversation,
    getFilteredOptions,
  } = useConversationState();

  useEffect(() => {
    if (isOpen) {
      resetConversation();
      // 阻止 body 滾動
      document.body.style.overflow = 'hidden';
    } else {
      // 恢復 body 滾動
      document.body.style.overflow = 'unset';
    }

    // 清理函數：組件卸載時恢復滾動
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[2000] flex items-center justify-center transition-all p-4"
      style={{
        backgroundImage: `url('/img/goty2024/hero-bricks.png')`,
        backgroundRepeat: 'repeat',
        backgroundColor: 'rgba(0,0,0,0.90)',
      }}
    >
      <button
        className="absolute top-4 right-4 text-white text-sm font-bold border-2 border-white rounded-lg px-3 py-1.5 z-60"
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        aria-label="關閉"
      >
        離開
      </button>
      <div
        className="flex flex-col md:flex-row items-center justify-center relative w-full max-w-4xl"
        onClick={e => e.stopPropagation()}
      >
        <div className="w-full md:w-1/2 mb-4 md:mb-0 md:pr-4">
            <img
                src="/img/goty2024/hero-counter.png"
                alt="售票亭"
                className="object-contain w-48 md:w-full max-w-xs mx-auto"
            />
        </div>
        <div className="w-full md:w-1/2 flex flex-col justify-center">
            <div className="relative bg-white p-3 md:p-4 rounded-lg shadow-md mb-3 md:mb-4">
                <div className="absolute left-1/2 md:left-0 top-0 md:top-1/2 w-3 h-3 md:w-4 md:h-4 bg-white transform -translate-x-1/2 md:-translate-x-2 -translate-y-1/2 md:translate-y-0 rotate-45" />
                <div className="text-black text-sm md:text-base">
                    {isChallengeMode ? (
                      <div>
                        <p className="text-lg md:text-2xl font-bold mb-2 md:mb-4">我很好奇...</p>
                        <p className="mb-2 md:mb-4 text-sm">第 {currentQuestionIndex + 1} / 5 題</p>
                        <p className="font-bold mb-2 md:mb-4 text-sm md:text-base">{challengeQuestions[currentQuestionIndex]?.content}</p>
                      </div>
                    ) : (
                      replyMessage
                    )}
                </div>
            </div>
            <div className="w-full space-y-2 md:space-y-3">
                {isChallengeMode ? (
                  // 挑戰模式：顯示選項
                  challengeQuestions[currentQuestionIndex]?.options.map((option) => (
                    <PuzzleOptionButton
                      key={option.key}
                      onClick={() => handleChallengeAnswer(challengeQuestions[currentQuestionIndex].id, option.key)}
                    >
                      {option.imgSrc ? (
                        <img 
                          src={option.imgSrc} 
                          alt={`選項 ${option.key}`}
                          className="w-16 md:w-24 h-auto object-contain"
                        />
                      ) : (
                        <span className="text-sm md:text-base">{option.text}</span>
                      )}
                    </PuzzleOptionButton>
                  ))
                ) : !isShowingResult ? (
                  // 一般模式：顯示對話選項
                  currentOptions.map((option) => (
                    <PuzzleOptionButton
                      key={option.id}
                      selected={selectedOptionId === option.id}
                      onClick={() => handleOptionSelect(option)}
                    >
                      <span className="text-sm md:text-base">{option.text}</span>
                    </PuzzleOptionButton>
                  ))
                ) : null}
            </div>
        </div>
      </div>
    </div>
  );
}

export default CounterModal;
